export default __webpack_public_path__ + "static/stayUpToDateM-347483ee742c16ecddad70945bd10756.png";